if (!customElements.get("m-scrolling-promotion")) {
  class MScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      this._observer = null;
    }

    connectedCallback() {
      this.promotion = this.querySelector(".m-promotion");
      // Stay stuck until section is in view (and respect reduced-motion).
      this.classList.add("m-scrolling-promotion--paused");
      this.init();
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }

    init() {
      if (!this.promotion || this.childElementCount !== 1) return;

      this.promotion.classList.add("m-promotion--animated");

      for (let i = 0; i < 10; i++) {
        this.clone = this.promotion.cloneNode(true);
        this.clone.setAttribute("aria-hidden", true);
        this.appendChild(this.clone);
      }

      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        this.scrollingPause();
        return;
      }

      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
              this.scrollingPlay();
            } else {
              this.scrollingPause();
            }
          });
        },
        {
          root: null,
          // Start only when a meaningful part of the strip is on screen.
          threshold: [0, 0.2, 0.4],
          rootMargin: "0px",
        }
      );

      this._observer.observe(this);
    }

    scrollingPlay() {
      this.classList.remove("m-scrolling-promotion--paused");
    }

    scrollingPause() {
      this.classList.add("m-scrolling-promotion--paused");
    }
  }

  customElements.define("m-scrolling-promotion", MScrollingPromotion);
}
